<h4 class="font-bold" style="font-size: 18px">{{ "menu.catalog" | translate }}</h4>

<p-card>
  <form [formGroup]="form">
    <div class="grid">
      @if(totalRecords && totalRecords >= 29600){
      <div class="lg:col-12 md:col-12 sm:col-12">
        <p-message severity="info"  [closable]="false">
          <ng-template #icon>
            <i class="pi pi-exclamation-triangle"  style="font-size: 1.5rem"></i>
          </ng-template>
          <div class="pl-2" [innerHTML]="'products.useFilterToShowProducts' | translate"></div>
        </p-message>
      </div>
      }
      <div class="lg:col-3 md:col-3 sm:col-4">
        <p-select
          [formControlName]="'shop'"
          (ngModelChange)="filterGlobal($event, 'shop')"
          [options]="shops"
          class="w-full">
          <ng-template let-shop pTemplate="item">
            <div>
              <span class="font-bold">{{ shop.shopName }}</span> - <span>{{ shop.shopChannel.channelName | translate }}</span>
            </div>
          </ng-template>
          <ng-template let-selectedItem pTemplate="selectedItem">
            @if (selectedItem) {
              <p class="inline font-bold line-height-1">{{ selectedItem.shopName + " - " }}</p>
              <p class="inline line-height-1">{{ selectedItem.shopChannel.channelName | translate}}</p>
            }
          </ng-template>
        </p-select>
      </div>
      @if(locales.length > 1) {
        <div class="xl:col-1 lg:col-2 md:col-2 sm:col-4">
          <p-select
            [(ngModel)]="selectedLocale"
            [options]="locales"
            [ngModelOptions]="{ standalone: true }"
            class="w-full"
            (ngModelChange)="updateLocale($event)"></p-select>
        </div>
      }
      <div class="lg:col-3 md:col-3 sm:col-4">
        <!-- <input
          type="text"
          pInputText
          [formControlName]="fields[1].name"
          (keydown.enter)="filterGlobal($event, 'input')"
          [placeholder]="fields[1].placeholder"
          class="w-full block" /> -->
          <p-autoComplete
          multiple
          [typeahead]="false"
          [formControlName]="fields[1].name"
          [placeholder]="fields[1].placeholder | translate"
          (keydown)="onFilterKeydown($event, fields[1])"
          (paste)="onFilterPaste($event, fields[1])"
          (onUnselect)="filterGlobal($event, 'input')"
          (keydown.enter)="filterGlobal($event, 'input')"
          class="w-full block" />
      </div>
      <span
        style="color: #aaa"
        class="lg:col-3 md:col-3 sm:col-4 pl-1 flex align-items-center cursor-pointer underline"
        (click)="resetSearch()">
        {{'global.removeSearch' | translate}}
      </span>
      <div [class]="locales.length > 1 ?  'xl:col-2 lg:col-2 md:col-2 ' : 'xl:col-3 lg:col-3 md:col-3'" class="sm:col-4 text-right">
        <div class="inline-flex items-center gap-2">
          <p-button icon="pi pi-sync" pTooltip="{{ 'products.reloadProducts' | translate }}" tooltipPosition="bottom"
            [rounded]="true" [outlined]="true" (onClick)="searchProducts()" [loading]="loading" />
          <p-button [outlined]="true" (click)="openFilterModal()" class="full-height-button">
            <i class="pi pi-filter"></i>
            @if (tags.length > 0) {
            <p-badge [value]="tags.length" severity="info" class="flex align-content-center filter-badge" />
            }
            <span class="pl-2 font-semibold">{{'global.filter' | translate}}</span>
          </p-button>
        </div>
      </div>
      @if (tags.length > 0) {
        @for (tag of tags; track $index) {
          <p-tag class="ml-3 mb-1">
            <span>{{tag.header | translate}}{{ ": " }} 
              @if (!tag.isMultiple) {
                @if (tag.isLengthOnly) {
                  {{ tag.valueString }} {{ 'global.selectedElements' | translate }}
                } @else {
                  {{ tag.valueString | translate }}
                }
              } @else {
                @for (item of tag.valueString; track $index) {
                  {{ item | translate }}{{ $index < tag.valueString.length - 1 ? ', ' : '' }}
                }
              }
            </span>
            <i class="pi pi-times-circle ml-1 cursor-pointer" (click)="removeFilter(tag.name, tag.parent)"></i>
          </p-tag>
        }
        <span style="color: #aaa" class="pl-3 align-items-center cursor-pointer underline" (click)="resetFilters()">
          {{'global.removeFilter' | translate}}
        </span>
      }
    </div>
  </form>
  @if (selectedProducts?.length > 0) {
    <div class="col-12 flex align-items-center">
      {{ selectAll ? totalRecords : selectedProducts.length }} {{ "products.selectedProducts" | translate }}
      <p-button
        [text]="true"
        (click)="selectAllProducs()"
        label="{{ 'products.selectMaxProducts' | translate }}"></p-button>
      <p-button
        [text]="true"
        (click)="removeSelection()"
        severity="danger"
        label="{{ 'buttons.removeSelection' | translate }}"></p-button>
      <!-- TODO enable bulk edit -->
     <!--  <p-button
        [text]="true"
        (click)="openEditProductsDialog()"
        icon="pi pi-file-edit font-semibold"
        label="{{ 'buttons.edit' | translate }}"></p-button> -->
      <p-button
        [text]="true"
        (click)="exportProducts()"
        icon="pi pi-upload font-semibold"
        label="{{ 'buttons.export' | translate }}"></p-button>
    </div>
  }
</p-card>
<!-- <div class="h-0.5rem"></div> -->

<div style="margin-top: 20px">
  <p-table
    #dt2
    class="table-shadow"
    [value]="products"
    [(selection)]="selectedProducts"
    [selectionPageOnly]="true"
    [scrollable]="true"
    selectionMode="single"
    [rowHover]="true"
    scrollHeight="calc(100vh - 300px)"
    [paginator]="true"
    [rows]="100"
    [lazy]="true"
    [loading]="loading"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="loadProducts($event)"
    [showCurrentPageReport]="true"
    (selectionChange)="onSelectionChange($event)"
    [currentPageReportTemplate]="'table.currentPageReportTemplate' | translate"
    [rowsPerPageOptions]="[50, 100, 200]"
    [tableStyle]="{ 'min-width': '50rem' }"
    [globalFilterFields]="['shopName', 'shopCode', 'legalEntityName']"
    [totalRecords]="totalRecords">
    <ng-template pTemplate="header">
      <tr>
        <th class="w-4rem" id="table-checkbox">
          <!-- <p-tableHeaderCheckbox /> -->
        </th>
        @for (header of headers; track $index) {
          <th
            [pSortableColumn]="header.sortColumn || header.id"
            [ngStyle]="{
              'font-size': '0.8rem',
              'font-weight': '700',
              'max-width': header.id === 'category' ? '150px' : 'none',
            }"
            [id]="header.id">
            <span>{{ header.value | translate}}</span>
            <p-sortIcon [field]="header.id" />
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
      <tr>
        <td>
         <!--  <p-tableCheckbox [value]="product" /> -->
        </td>
        @for (header of headers; track $index) {
          <td [class]="getRowClass(product, header)" (click)="rowClick($event, product)">
            @if (header.id === "product") {
              <div class="flex flex-column align-items-center" style="gap: 5px">
                <img [src]="product.image" alt="Product" style="width: 60px; height: 60px; object-fit: cover" />
                @if(isPublicationStatusErrors(product)) {
                  <p-tag [severity]="getSeverityForPublicationStatus(product)" [tp]="synchStatus" [tpPlacement]="'bottom'" [tpPopperWidth]="'400px'"> {{ product.status | translate }}</p-tag>
                  <ng-template #synchStatus let-hide>
                    @for(msg of getPublicationStatusErrors(product); track $index) {
                      @if(msg.length > 50) {
                      <div class="truncated">
                        <span >{{ msg }}</span><br>
                      </div>
                      
                      }@else {
                        <span >{{ msg }}</span><br>
                      }
                    }
                  </ng-template>
                }@else {
                  <p-tag [severity]="getSeverityForPublicationStatus(product)"> {{ product.status | translate }}</p-tag>  
                }
              </div>
            } @else if (header.id === "ean") {
              @for (item of product.ean; track $index) {
                {{ item }}
              }
            } @else if (header.id === "editorialCharter") {
              <div class="flex flex-column align-items-center">
                <p-tag class="text-center" [severity]="getSeverity(product.editorialCharter?.status)">
                  {{ product.editorialCharter?.status | translate }}
                </p-tag>
                @if (
                  product?.editorialCharter?.description !== "ACCEPTED" &&
                  product?.editorialCharter?.description.length >= 62
                ) {
                  <div class="text-xs truncate" [tp]="tpl" [tpPlacement]="'bottom'" [tpPopperWidth]="'400px'">
                    {{ product?.editorialCharter?.description | translate }}
                  </div>
                  <ng-template #tpl let-hide>
                    <div class="flex align-items-center text-justify p-2" style="line-height: 13px; font-size: 11px">
                      {{ product?.editorialCharter?.description | translate }}
                    </div>
                  </ng-template>
                } @else if(product?.editorialCharter?.description ){
                  <div class="text-xs text-center mt-2">
                    {{ product?.editorialCharter?.description | translate }}
                  </div>
                }
              </div>
            } @else if (header.id === "format") {
              <div class="flex flex-column align-items-center">
                <p-tag [severity]="getSeverity(product.format)">
                  {{ product.format | translate }}
                </p-tag>
              </div>
            } @else {
              {{ product[header.id] }}
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</div>
